/**
 * Victorian Beauty Theme - Main JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {

  // ===== Featured Tabs Filter =====
  const tabs = document.querySelectorAll('.featured-tab');
  if (tabs.length > 0) {
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        // TODO: Implement AJAX collection filtering
        // const filter = tab.dataset.filter;
      });
    });
  }

  // ===== Mobile Menu Toggle =====
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      const nav = document.querySelector('.main-nav');
      if (nav) nav.classList.toggle('is-open');
    });
  }

  // ===== Add to Cart (AJAX) =====
  document.querySelectorAll('.product-add-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      const form = btn.closest('form');
      if (!form) return;

      e.preventDefault();
      btn.textContent = '追加中...';
      btn.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          btn.textContent = '追加しました ✓';
          // Update cart count
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = cart.item_count;

          setTimeout(() => {
            btn.textContent = 'カートに追加';
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = 'エラーが発生しました';
          setTimeout(() => {
            btn.textContent = 'カートに追加';
            btn.disabled = false;
          }, 2000);
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        btn.textContent = 'カートに追加';
        btn.disabled = false;
      }
    });
  });

  // Collection products should be visible immediately, without waiting for an observer.
  // Keep the remaining page animations and all cart/menu handlers unchanged.
  const immediateProducts = document.body.dataset.immediateProductCards === 'true';

  // ===== Scroll-triggered Animations =====
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.category-card, .product-card, .review-card, .cross-sell-card, .value-item').forEach(el => {
    if (immediateProducts && el.matches('.product-card')) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  // CSS class for animation
  const style = document.createElement('style');
  style.textContent = '.is-visible { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(style);

});
